import * as BaseSizes from './Size';

export const Size = {
  Small: BaseSizes.X3Small,
  Medium: 1.5,
  Large: BaseSizes.X2Small,
};

export const Radius = {
  XXSmall: BaseSizes.X2Small,
  XSmall: BaseSizes.XSmall,
  Small: 6,
  Medium: BaseSizes.Small,
  Large: BaseSizes.Medium,
  XLarge: BaseSizes.Large,
};
